<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.inventory.text") }}</h1>

      <div role="tablist">
        <b-card no-body class=" shadow-none mb-3">
          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.inventory.line-1") }}
            </p>

            <p class="mt-3 mb-3">{{ $t("help.platform.inventory.line-2") }}</p>
            <p class="mt-3 mb-3">{{ $t("help.platform.inventory.line-3") }}</p>
            <img src="@/assets/images/help/inventory.png" class="image" />
          </b-card-body>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>{{ $t("help.platform.inventory.process-datasource-definition.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col1" :visible="col == 'col1'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-0">
                {{ $t("help.platform.inventory.process-datasource-definition.line-1") }}
              </p>

              <p class="mt-3 mb-3">
                {{ $t("help.platform.inventory.process-datasource-definition.line-2") }}
              </p>

              <p class="mt-3 mb-3">
                {{ $t("help.platform.inventory.process-datasource-definition.line-3") }}
              </p>
              <img src="@/assets/images/help/organization-entities.png" class="image" />
              <p class="mt-3 mb-3">
                {{ $t("help.platform.inventory.process-datasource-definition.line-4") }}
              </p>

              <p class="mt-3 mb-3">
                {{ $t("help.platform.inventory.process-datasource-definition.organization.line-5") }}
              </p>
              <img src="@/assets/images/help/datasource.png" class="image" />
              <p class="mt-3 mb-3">
                {{ $t("help.platform.inventory.process-datasource-definition.line-6") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2' ? 'founded' : ''" v-b-toggle.col2>
              <div>{{ $t("help.platform.inventory.datasource-data-definition.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col2" :visible="col == 'col2'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.inventory.datasource-data-definition.line-1") }}
              </p>

              <img src="@/assets/images/help/datasource-data.png" class="image" />

              <p class="mt-3">{{ $t("help.platform.inventory.datasource-data-definition.line-2") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.inventory.datasource-data-definition.line-3") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.inventory.datasource-data-definition.line-4") }}</p>
              <img src="@/assets/images/help/new-data.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.inventory.datasource-data-definition.line-5") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.inventory.datasource-data-definition.line-6") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.inventory.datasource-data-definition.line-7") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col3' ? 'founded' : ''" v-b-toggle.col3>
              <div>{{ $t("help.platform.inventory.minimization.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col3" :visible="col == 'col3'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.inventory.minimization.line-1") }}
              </p>
            </b-card-body>

            <b-card no-body class="custom-accordion shadow-none mb-3 ml-4">
              <b-card-header header-tag="header" role="tab">
                <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col4' ? 'founded' : ''" v-b-toggle.col4>
                  <div>{{ $t("help.platform.inventory.collect-minimization.text") }}</div>
                  <i class="mdi mdi-minus accor-plus-icon"></i>
                </a>
              </b-card-header>
              <b-collapse id="col4" :visible="col == 'col4'" accordion="help-accordionlist2" role="tabpanel">
                <b-card-body>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.collect-minimization.line-1") }}</p>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.collect-minimization.line-2") }}</p>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.collect-minimization.line-3") }}</p>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.collect-minimization.line-4") }}</p>

                  <img src="@/assets/images/help/collect-minimization.png" class="image" />
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.collect-minimization.line-5") }}</p>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.collect-minimization.line-6") }}</p>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="custom-accordion shadow-none mb-3 ml-4">
              <b-card-header header-tag="header" role="tab">
                <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col5' ? 'founded' : ''" v-b-toggle.col5>
                  <div>{{ $t("help.platform.inventory.transfer-minimization.text") }}</div>
                  <i class="mdi mdi-minus accor-plus-icon"></i>
                </a>
              </b-card-header>
              <b-collapse id="col5" :visible="col == 'col5'" accordion="help-accordionlist2" role="tabpanel">
                <b-card-body>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.transfer-minimization.line-1") }}</p>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.transfer-minimization.line-2") }}</p>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.transfer-minimization.line-3") }}</p>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.transfer-minimization.line-4") }}</p>

                  <img src="@/assets/images/help/transfer-minimization.png" class="image" />
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.transfer-minimization.line-5") }}</p>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.transfer-minimization.line-6") }}</p>
                </b-card-body>
              </b-collapse>
            </b-card>
          </b-collapse>
        </b-card>

        <!-- <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col4' ? 'founded' : ''" v-b-toggle.col4>
              <div>{{ $t("help.platform.inventory.collect-minimization.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col4" :visible="col == 'col4'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.collect-minimization.line-1") }}</p>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.collect-minimization.line-2") }}</p>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.collect-minimization.line-3") }}</p>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.collect-minimization.line-4") }}</p>

              <img src="@/assets/images/help/collect-minimization.png" class="image" />
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.collect-minimization.line-5") }}</p>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.collect-minimization.line-6") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card> -->

        <!-- <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col5' ? 'founded' : ''" v-b-toggle.col5>
              <div>{{ $t("help.platform.inventory.transfer-minimization.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col5" :visible="col == 'col5'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.transfer-minimization.line-1") }}</p>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.transfer-minimization.line-2") }}</p>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.transfer-minimization.line-3") }}</p>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.transfer-minimization.line-4") }}</p>

              <img src="@/assets/images/help/transfer-minimization.png" class="image" />
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.transfer-minimization.line-5") }}</p>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.transfer-minimization.line-6") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card> -->

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col6' ? 'founded' : ''" v-b-toggle.col6>
              <div>{{ $t("help.platform.inventory.update.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col6" :visible="col == 'col6'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.update.line-1") }}</p>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.update.line-2") }}</p>
              <img src="@/assets/images/help/inventory-types.png" class="image" />
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.update.line-3") }}</p>
              <img src="@/assets/images/help/inventory-filter.png" class="image" />
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.update.line-4") }}</p>
              <img src="@/assets/images/help/inventory-add.png" class="image" />

              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.update.line-5") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col7' ? 'founded' : ''" v-b-toggle.col7>
              <div>{{ $t("help.platform.inventory.bulk-update.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col7" :visible="col == 'col7'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.bulk-update.line-1") }}</p>
              <img src="@/assets/images/help/inventory-bulk-update.png" class="image" />
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.bulk-update.line-2") }}</p>
              <img src="@/assets/images/help/inventory-bulk-update-type.png" class="image" />
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.bulk-update.line-3") }}</p>

              <ul class="mb-3">
                <li>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.bulk-update.line-4") }}</p>
                </li>
                <li>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.bulk-update.line-5") }}</p>
                </li>
                <li>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.bulk-update.line-6") }}</p>
                </li>
              </ul>
              <img src="@/assets/images/help/inventory-bulk-update-button.png" class="image" />
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.bulk-update.line-7") }}</p>
              <ul class="mb-3">
                <li>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.bulk-update.line-8") }}</p>
                </li>
                <li>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.bulk-update.line-9") }}</p>
                </li>
                <li>
                  <p class="mb-3 mb-3">{{ $t("help.platform.inventory.bulk-update.line-10") }}</p>
                </li>
              </ul>

              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.bulk-update.line-11") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col8' ? 'founded' : ''" v-b-toggle.col8>
              <div>{{ $t("help.platform.inventory.export.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col8" :visible="col == 'col8'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.export.line-1") }}</p>
              <img src="@/assets/images/help/inventory-export.png" class="image" />
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col9' ? 'founded' : ''" v-b-toggle.col9>
              <div>{{ $t("help.platform.inventory.save.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col9" :visible="col == 'col9'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3 mb-3">{{ $t("help.platform.inventory.save.line-1") }}</p>

              <a class="mt-3" href="/organization/file-manager">
                <p><i class="bx bx-support"></i> {{ $t("help.platform.inventory.save.line-2") }}</p>
              </a>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
